import type { PortOut, SwitchOut } from "../../api/types/siteSwitch";
import { CopyButton } from "../../components/ui/CopyButton";
import { buildSwitchInstructions } from "./buildSwitchInstructions";
import { getManagementMode } from "./managementMode";

// Read-only output for web-UI-managed switches: the recorded intent rendered as
// a numbered, copy-pasteable checklist. No queries — ports/nameByTag come from
// SwitchDetail (the single data owner). Renders nothing for cli switches.
export function WebUiInstructionsPanel({
  sw,
  ports,
  nameByTag,
}: {
  sw: SwitchOut;
  ports: PortOut[];
  nameByTag: Map<number, string>;
}) {
  if (getManagementMode(sw.vendor_extras) !== "web_ui") return null;
  const lines = buildSwitchInstructions(sw, ports, nameByTag);

  return (
    <div style={{ border: "1px solid var(--border)", borderRadius: 8, padding: 12, display: "grid", gap: 8 }}>
      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
        <strong style={{ fontSize: "0.9rem" }}>Web UI setup instructions</strong>
        <CopyButton value={lines.join("\n")} label="Copy all" />
      </div>
      <ol style={{ margin: 0, paddingLeft: 20, display: "grid", gap: 4, fontSize: "0.85rem" }}>
        {lines.map((line, i) => (
          <li key={i}>{line}</li>
        ))}
      </ol>
      <p style={{ margin: 0, fontSize: "0.75rem", color: "var(--text-dim)" }}>
        Apply these in the switch's web admin UI. Hub records the intent but does not push config to web-managed switches.
      </p>
    </div>
  );
}
